import { useEffect, useState } from "react";
import { Mail, Phone } from "lucide-react";
import { toast } from "sonner";
import { useAdminApi, errMsg } from "@/lib/site";

export const AdminTitle = ({ children, sub }) => (
  <div className="mb-6"><h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight">{children}</h1>{sub && <p className="text-sm text-slate-500 mt-1">{sub}</p>}</div>
);

const MessageCard = ({ m, onToggle }) => (
  <div className="rounded-2xl bg-white border p-5" data-testid={`admin-message-${m.id}`}>
    <div className="flex flex-wrap justify-between gap-3">
      <div>
        <p className="font-semibold">{m.name} {m.service && <span className="ml-2 rounded-full bg-blue-50 text-blue-700 text-xs px-2.5 py-0.5">{m.service}</span>}</p>
        <div className="flex flex-wrap gap-x-4 text-xs text-slate-500 mt-1">
          <a href={`mailto:${m.email}`} className="flex items-center gap-1 hover:text-blue-600"><Mail className="w-3 h-3" />{m.email}</a>
          {m.phone && <a href={`tel:${m.phone}`} className="flex items-center gap-1 hover:text-blue-600"><Phone className="w-3 h-3" />{m.phone}</a>}
          <span>{new Date(m.created_at).toLocaleString()}</span>
        </div>
      </div>
      <button onClick={() => onToggle(m)} data-testid={`admin-message-toggle-${m.id}`} className={`rounded-full px-4 py-1.5 text-xs font-semibold border ${m.handled ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-white hover:bg-slate-50"}`}>
        {m.handled ? "Handled" : "Mark handled"}
      </button>
    </div>
    <p className="mt-3 text-sm text-slate-700 whitespace-pre-wrap">{m.message}</p>
  </div>
);

const matches = (filter) => (m) => filter === "all" || (filter === "open" ? !m.handled : m.handled);

export default function AdminMessages() {
  const call = useAdminApi();
  const [list, setList] = useState(null);
  const [filter, setFilter] = useState("open");
  useEffect(() => { call("get", "/admin/messages").then(setList).catch((e) => toast.error(errMsg(e))); }, [call]);
  const toggle = async (m) => {
    try { await call("patch", `/admin/messages/${m.id}`, { handled: !m.handled }); setList(list.map((x) => x.id === m.id ? { ...x, handled: !m.handled } : x)); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const shown = (list || []).filter(matches(filter));
  return (
    <div data-testid="admin-messages">
      <AdminTitle sub="Enquiries sent through the contact form">Messages</AdminTitle>
      <div className="flex gap-2 mb-5">
        {["open", "handled", "all"].map((f) => (
          <button key={f} onClick={() => setFilter(f)} data-testid={`admin-messages-filter-${f}`} className={`rounded-full px-4 py-1.5 text-sm capitalize border ${filter === f ? "bg-slate-900 text-white border-slate-900" : "bg-white"}`}>{f}</button>
        ))}
      </div>
      {list && !shown.length && <p className="text-sm text-slate-500" data-testid="admin-messages-empty">Nothing here.</p>}
      <div className="space-y-3">
        {shown.map((m) => <MessageCard key={m.id} m={m} onToggle={toggle} />)}
      </div>
    </div>
  );
}
